export default "__VITE_ASSET__39d2c2ba__"